/**
 *
 * @notes I'm moving things around and wanted to outline the usage of this top level component. The naming convention
 * isn't quite right but the purpose of this comp is to determine if the cycle we are viewing analysis on is form the
 * demo tenant.
 * The reason why it is the top level component is because the page changes architecture based on demo mode so it needs
 * to be the first thing that happens.
 *
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Grid} from "react-bootstrap"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {DemoTenantContext} from "@irati/insights/context"

import {AnalysisNavigation} from "../../components/Analysis"
import {PageWithStickyFooter} from "../../components/Layout"
import Footer from "../../components/Wizard/Footer/Footer"
import {DEMO_DATA_BACKGROUND_COLOR} from "../../ui/colors"
import {Para} from "../../ui/Labels"
import sitemap from "../sitemap"


const StyledFooter = styled(Footer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const StyledPage = styled(PageWithStickyFooter)`
  background-color: ${DEMO_DATA_BACKGROUND_COLOR};
`

const StyledPara = styled(Para)`
  margin-bottom: 0;
  margin-right: ${padding.small};

`


class AnalysisController extends Component {
  constructor(props) {
    super(props)
    this.idNamespace = id("AnalysisController", this.props, {force: true})
  }

  renderFooter = () => {
    return (
      <StyledFooter>
        <StyledPara>
          <FormattedMessage id="insights.demo.analysis.info" />
        </StyledPara>
        <ButtonRouterLink
          primary
          to={sitemap.homepage.url}
          id={id("submit-btn", this.idNamespace)}>
          <FormattedMessage id="insights.demo.analysis.cta" />
        </ButtonRouterLink>
      </StyledFooter>
    )
  }

  render() {
    return (
      <DemoTenantContext.Consumer>
        {({cycleUuid}) => {
          const {match: {params}} = this.props
          const isDemo = params.scheduleId === cycleUuid

          if (isDemo) {
            return (
              <StyledPage id={this.idNamespace} footerChildren={this.renderFooter()}>
                <AnalysisNavigation {...this.props} id={this.idNamespace} />
              </StyledPage>
            )
          }

          return (
            <Grid>
              <AnalysisNavigation {...this.props} id={this.idNamespace} />
            </Grid>
          )
        }}
      </DemoTenantContext.Consumer>
    )
  }
}


AnalysisController.propTypes = {
  match: PropTypes.object.isRequired
}
AnalysisController.defaultProps = {}

export default AnalysisController
